/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-text-block': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M2 6.5A1.5 1.5 0 0 1 3.5 5h40a1.5 1.5 0 0 1 0 3h-40A1.5 1.5 0 0 1 2 6.5zm0 7A1.5 1.5 0 0 1 3.5 12h40a1.5 1.5 0 0 1 0 3h-40A1.5 1.5 0 0 1 2 13.5zm0 7A1.5 1.5 0 0 1 3.5 19h40a1.5 1.5 0 0 1 0 3h-40A1.5 1.5 0 0 1 2 20.5zm5 14A1.5 1.5 0 0 1 8.5 33h35a1.5 1.5 0 0 1 0 3h-35A1.5 1.5 0 0 1 7 34.5zm0 7A1.5 1.5 0 0 1 8.5 40h35a1.5 1.5 0 0 1 0 3h-35A1.5 1.5 0 0 1 7 41.5zm-2-7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>'
  }
})
